import React, { useState } from 'react';
import {
    Box, Button, FormControl, IconButton, MenuItem,
    Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
     Typography, Menu, ListItemIcon, ListItemText, Pagination, Checkbox
  } from '@mui/material';
import {History, MoreVert, } from '@mui/icons-material';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import Navbar from '../Layouts/Navbar';
import Snackbar from '@mui/material/Snackbar';
import EmailIcon from "@mui/icons-material/Email";
import MuiAlert from '@mui/material/Alert';
import HistoriqueModal from './HistoriqueModal';


export default function EmailTable() {
  const [openhis, setOpenHis] = useState(false);
  const handleOpenHis = () => setOpenHis(true);
  const handleCloseHis = () => setOpenHis(false);



  const [snack, setSnack] = useState({ open: false, message: '', type: 'success' });
  const handleSnack = (message, type = 'success') => {
    setSnack({ open: true, message, type });
  };
  
  const handleCloseSnack = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnack({ ...snack, open: false });
  };

  const [open, setOpen] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [menuRowId, setMenuRowId] = useState(null);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(1);
  
  // State for selected rows/checkboxes
  const [selected, setSelected] = useState([]);
  const [groupAction, setGroupAction] = useState('');
  const rows = [
    {
      id: 1,
      sujet: "STJG - Validation de la navette du 18/12/2024",
      template: "navette-validee",
      destinataire: "sara.eljoumani@stjg.ma",
      cc: 0,
      pj: 0,
      etat: "Échoué",
      renvoi: 0,
      dateEnvoi: "26.12.2024 15:52",
    },
    {
      id: 2,
      sujet: "STJG - Annulation de la navette du 20/12/2024",
      template: "navette-annulee",
      destinataire: "nom@stjg.ma",
      cc: 0,
      pj: 0,
      etat: "En attente",
      renvoi: 0,
      dateEnvoi: "",
    },
    {
      id: 3,
      sujet: "STJG - Annulation de la navette du 14/12/2024",
      template: "navette-annulee",
      destinataire: "nom7@stjg.ma",
      cc: 0,
      pj: 0,
      etat: "Envoyé",
      renvoi: 0,
      dateEnvoi: "26.12.2024 13:05",
    },
  ];
  
  

  const handleDelete = () => {
    try {
      // Delete logic would go here
      handleSnack('Réservation(s) supprimée(s) avec succès', 'success');
      handleMenuClose();
    } catch (error) {
      handleSnack("Erreur lors de la suppression de la réservation", 'error');
    }
  };

  const handleModify = () => {
    try {
      // Modify logic would go here
      handleSnack('Réservation modifiée avec succès', 'success');
      handleMenuClose();
    } catch (error) {
      handleSnack("Erreur lors de la modification de la réservation", 'error');
    }
  };

  const handleMenuClick = (event, id) => {
    setAnchorEl(event.currentTarget);
    setMenuRowId(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuRowId(null);
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(1);
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map(n => n.id);
      setSelected(newSelected);
    } else {
      setSelected([]);
    }
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    
    setSelected(newSelected);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const handleGroupAction = () => {
    if (groupAction === 'navette' && selected.length > 0) {
      handleSnack('Navette assignée avec succès', 'success');
      setGroupAction('');
    }
  };

  const paginatedRows = rows.slice((page - 1) * rowsPerPage, page * rowsPerPage);
  const pageCount = Math.ceil(rows.length / rowsPerPage);

  return (
    <Box>
      <Navbar />
      <Box p={2}>
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box display="flex" alignItems="center" onClick={() => setOpen(!open)} sx={{ cursor: 'pointer' }}>
            <EmailIcon />
            <Typography variant="h6">NOTIFICATIONS</Typography>
          </Box>
        </Box>
        {/* Bulk Actions */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box display="flex" alignItems="center" gap={2}>
            <Typography>Actions groupées</Typography>
            <FormControl size="small" sx={{
                minWidth: 150 ,
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                }
              }}>
              <Select
                value={groupAction}
                onChange={(e) => setGroupAction(e.target.value)}
                displayEmpty
              >
                <MenuItem value="" disabled><em>Sélectionner</em></MenuItem>
                <MenuItem value="Supprimer">Renvoyer</MenuItem>
              </Select>
            </FormControl>
            <Button
              variant="contained"
              disabled={!groupAction || selected.length === 0}
              onClick={handleGroupAction}
              sx={{
                bgcolor: 'red',
                textTransform: 'none',
                '&:hover': { bgcolor: 'red' },
                '&.Mui-disabled': { bgcolor: '#f5f5f5', color: '#bdbdbd' }
              }}
            >
              Appliquer
            </Button>
          </Box>
          <Typography>{selected.length} sélectionnés / {rows.length} entrées</Typography>
        </Box>

        {/* Table */}
        <TableContainer component={Paper} variant="outlined">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      indeterminate={selected.length > 0 && selected.length < rows.length}
                      checked={rows.length > 0 && selected.length === rows.length}
                      onChange={handleSelectAll}
                      sx={{
                        '&.MuiCheckbox-indeterminate': { color: '#000' },
                        '&.Mui-checked': { color: '#000' },
                      }}
                    />
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Sujet</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Template</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Destinataire</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>CC</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>PJ</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>État</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Renvoi</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Date d'envoi</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedRows.map((row) => {
                  const isItemSelected = isSelected(row.id);
                  return (
                    <TableRow key={row.id} hover selected={isItemSelected}>
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={isItemSelected}
                          onChange={(event) => handleSelectOne(event, row.id)}
                          sx={{
                            '&.MuiCheckbox-indeterminate': { color: '#000' },
                            '&.Mui-checked': { color: '#000' },
                          }}
                        />
                      </TableCell>
                      <TableCell>{row.sujet}</TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            backgroundColor: '#000',
                            color: '#fff',
                            borderRadius: '16px',
                            px: 1.5,
                            py: 0.5,
                            fontSize: '0.75rem',
                            display: 'inline-block',
                          }}
                        >
                          {row.template}
                        </Box>
                      </TableCell>
                      <TableCell>{row.destinataire}</TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            backgroundColor: row.cc === 0 ? '#dc3545' : '#28a745',
                            color: 'white',
                            borderRadius: '50%',
                            width: 20,
                            height: 20,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: '0.75rem',
                          }}
                        >
                          {row.cc}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            backgroundColor: row.pj === 0 ? '#dc3545' : '#28a745',
                            color: 'white',
                            borderRadius: '50%',
                            width: 20,
                            height: 20,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: '0.75rem',
                          }}
                        >
                          {row.pj}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            backgroundColor: row.etat === 'Échoué' ? '#dc3545' :
                                            row.etat === 'En attente' ? '#f1c40f' :
                                            '#28a745',
                            color: 'white',
                            borderRadius: '8px',
                            px: 1.5,
                            py: 0.5,
                            fontSize: '0.75rem',
                            display: 'inline-block',
                          }}
                        >
                          {row.etat}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            backgroundColor: '#000',
                            color: '#fff',
                            borderRadius: '50%',
                            width: 20,
                            height: 20,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: '0.75rem',
                          }}
                        >
                          {row.renvoi}
                        </Box>
                      </TableCell>
                      <TableCell>{row.dateEnvoi}</TableCell>
                      <TableCell>
                        <IconButton onClick={(e) => handleMenuClick(e, row.id)}>
                          <MoreVert />
                        </IconButton>
                        <Menu
                          anchorEl={anchorEl}
                          open={menuRowId === row.id && openMenu}
                          onClose={handleMenuClose}
                          PaperProps={{
                            sx: {
                              minWidth: '200px',
                              '& .MuiMenuItem-root': {
                                color: 'black',
                                '& .MuiListItemIcon-root': { color: 'black' },
                                '&:hover': {
                                  backgroundColor: 'red',
                                  color: 'white',
                                  '& .MuiListItemIcon-root': { color: 'white' },
                                },
                              },
                            },
                          }}
                        >
                            <MenuItem>
                            <ListItemIcon><RemoveRedEyeIcon fontSize="small" /></ListItemIcon>
                            <ListItemText>Afficher</ListItemText>
                            </MenuItem>
                            <MenuItem sx={{ color: 'red' }} onClick={handleOpenHis}>
                            <ListItemIcon sx={{ color: 'red' }}><History fontSize="small" /></ListItemIcon>
                            <ListItemText>Historique</ListItemText>
                            </MenuItem>
                            <MenuItem sx={{ color: 'red' }} >
                            <ListItemIcon sx={{ color: 'red' }}><RestartAltIcon fontSize="small" /></ListItemIcon>
                            <ListItemText>Renvoyer</ListItemText>
                            </MenuItem>
                        </Menu>
                        </TableCell>
                    </TableRow>
                    );
                })}
                </TableBody>
            </Table>
        </TableContainer>

        {/* Pagination */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
          <Typography>{rows.length} entrées</Typography>
          <Box display="flex" gap={2} alignItems="center">
            <FormControl size="small" sx={{
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': { borderColor: '#000' },
                '&.Mui-focused fieldset': { borderColor: 'red' },
              }
            }}>
              <Select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
              </Select>
            </FormControl>
            <Pagination
              count={pageCount}
              page={page}
              onChange={handleChangePage}
              variant="outlined"
              shape="rounded"
            />
          </Box>
        </Box>
      </Box>

      <Snackbar 
        open={snack.open} 
        autoHideDuration={3000} 
        onClose={handleCloseSnack} 
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MuiAlert 
          onClose={handleCloseSnack} 
          severity={snack.type} 
          elevation={6} 
          variant="filled" 
          sx={{ width: '100%', bgcolor: snack.type === 'success' ? 'green' : 'red' }}
        >
          {snack.message}
        </MuiAlert>
      </Snackbar>

    <HistoriqueModal open={openhis} handleClose={handleCloseHis} />
    </Box>
  );
}